/* ══════════════════════════════════════════════════════════════════
   轨道尺的运行时。全站唯一一份 —— 车型 tabs、分类入口、知识库、
   口碑墙，谁要滑动杆都用它，不许各写一套。

   一个「尺的作用域」是一个带 `data-rail-scope` 的元素，里面有：
     · 一条或多条 `[data-track]` —— 会横滑的内容带（tabs 那种一次只显示一条）
     · 一个 `[data-rail]` —— 尺本身，里面是 `[data-rail-progress]` 和两个箭头

   **量的永远是「现在看得见的那条带」**：featured 的四个面板里各有一条带，
   隐藏的那几条 scrollWidth 是 0，量错了尺就永远显示「放得下」。
   看得见 = `offsetParent !== null`，不用去问是哪个 tab 选中了。

   除了尺，鼠标还能**直接抓着带子推**（见文件末尾那一节）。

   事件全部委托到 document。滚动事件不冒泡，所以用捕获阶段听 ——
   这样运营在编辑器里现加一个 section，尺和拖拽照样活。
   ══════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  function visibleTrack(scope) {
    var tracks = [].slice.call(scope.querySelectorAll('[data-track]'));
    for (var i = 0; i < tracks.length; i++) {
      if (tracks[i].offsetParent !== null) return tracks[i];
    }
    return tracks[0] || null;
  }

  function sync(scope) {
    if (!scope) return;
    var track = visibleTrack(scope);
    if (!track) return;

    var scrollable = track.scrollWidth - track.clientWidth;
    /* 差不到一格就当放得下：亚像素误差不该让箭头闪出来 */
    var fits = scrollable < 8;

    /* 抓手光标只在真的推得动的时候给 —— 宽度在这儿已经量过了，
       底下那套拖拽不该为了同一件事再量一遍。
       （所以顺序是先量带子再管尺：没配尺的带子也要能推。） */
    track.classList.toggle('is-draggable', !fits);

    var rail = scope.querySelector('[data-rail]');
    if (!rail) return;
    if (fits) { rail.hidden = true; return; }
    rail.hidden = false;

    var progress = rail.querySelector('[data-rail-progress]');
    var prev = rail.querySelector('[data-rail-prev]');
    var next = rail.querySelector('[data-rail-next]');

    var ratio = track.clientWidth / track.scrollWidth;
    var pos = track.scrollLeft / scrollable;
    if (progress) {
      progress.style.width = Math.max(ratio * 100, 12) + '%';
      progress.style.transform = 'translateX(' + (pos * (100 / Math.max(ratio, 0.12) - 100)) + '%)';
    }
    if (prev) prev.disabled = track.scrollLeft <= 2;
    if (next) next.disabled = track.scrollLeft >= scrollable - 2;
  }

  function page(scope, dir) {
    var track = visibleTrack(scope);
    if (!track) return;
    /* 一次翻**一格**，不是一屏：翻一屏会跳过正在看的那张的邻居 */
    var cell = track.querySelector('.eb-track__cell');
    var step = cell
      ? cell.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap || 0)
      : track.clientWidth;
    track.scrollBy({ left: dir * step, behavior: 'smooth' });
  }

  function syncAll() {
    document.querySelectorAll('[data-rail-scope]').forEach(sync);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-rail-prev], [data-rail-next]');
    if (!btn) return;
    page(btn.closest('[data-rail-scope]'), btn.hasAttribute('data-rail-next') ? 1 : -1);
  });

  /* 滚动不冒泡 —— 捕获阶段才听得到轨道自己的滚动 */
  document.addEventListener('scroll', function (e) {
    var track = e.target;
    if (track && track.nodeType === 1 && track.hasAttribute && track.hasAttribute('data-track')) {
      sync(track.closest('[data-rail-scope]'));
    }
  }, true);

  window.addEventListener('resize',
    (window.EB && EB.debounce) ? EB.debounce(syncAll, 150) : syncAll, { passive: true });

  document.addEventListener('shopify:section:load', syncAll);
  document.addEventListener('DOMContentLoaded', syncAll);
  syncAll();

  /* ══════════════════════════════════════════════════════════════
     抓着推 —— 补给鼠标的横滑手势

     为什么要有：带子的滚动条是藏起来的（component-rail.css 里的
     `scrollbar-width: none`），拿鼠标的人就只剩尺上那对 40px 箭头，
     一次一格。卡片看着能推、推不动 —— 那是个假的可供性。

     **只管鼠标。** 触屏本来就能滑，触控板有两指横扫，插进去只会把
     系统的惯性抢掉，越帮越忙。

     光标状态两个类分开写，因为寿命不一样：
       `.is-dragging`  手按着的那一段（抓紧的光标、不许选中文字）
       `.is-loose`     从按下一直到落位动画走完（吸附和平滑滚动都关掉）
     松手那一瞬间光标要立刻松开，可吸附还不能还回去 —— 合成一个类，
     落位滚到一半就会被 mandatory 吸附抢走一次位置，看着像回弹。
     ══════════════════════════════════════════════════════════════ */

  var DRAG_MIN = 6;      /* 走够这么多像素才算「在推」，不到就是手抖的点击 */
  var FLICK = 0.45;      /* px/ms：松手那下还这么快就是「甩」，多送一格 */
  var FLICK_WIN = 70;    /* 甩得多快，只看松手前这一小段 */
  var FLICK_STALE = 80;  /* 手停了这么久再松开，就不算甩 */
  var SETTLE = 460;      /* 落位动画兜底多久把吸附还回去 */
  var NO_DRAG = 'input, textarea, select, video, audio, [contenteditable], [data-no-drag]';

  var drag = null;

  function calm() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /* 甩的速度＝松手前 FLICK_WIN 毫秒里手走了多远。

     不能拿「最后两个 pointermove」算：120Hz 的屏幕两帧只隔 4ms，
     取样噪声比信号大；也不能从按下算平均值，先慢慢挪再甩一把的话，
     前面那段会把速度抹平。取一小段窗口，两头都不吃亏。 */
  function flickSpeed(hist, tEnd) {
    var last = hist[hist.length - 1];
    if (!last) return 0;
    /* 手停住再松开，意思是「就停这儿」，不是甩 */
    if (tEnd - last.t > FLICK_STALE) return 0;

    var first = last;
    for (var i = hist.length - 1; i >= 0; i--) {
      if (last.t - hist[i].t > FLICK_WIN) break;
      first = hist[i];
    }
    var dt = last.t - first.t;
    return dt > 0 ? (last.x - first.x) / dt : 0;
  }

  /* 松手落位。吸附点＝卡片左沿对齐「滚动内边距之后」的那条线 ——
     和 CSS 里 `scroll-snap-align: start` ＋ `scroll-padding-inline`
     算的是同一条线，所以落完位把吸附还回去不会再跳一下。

     这一步必须自己算：直接把 mandatory 还回去让浏览器自己吸，
     它会在我们停的位置上再动一次，两段动画打架。 */
  function settle(track, v) {
    var cells = track.querySelectorAll('.eb-track__cell');
    if (!cells.length) return;

    var cs = getComputedStyle(track);
    var pad = parseFloat(cs.getPropertyValue('scroll-padding-inline-start'));
    if (isNaN(pad)) pad = parseFloat(cs.getPropertyValue('padding-inline-start')) || 0;
    var anchor = track.getBoundingClientRect().left + pad;

    var offsets = [];
    var best = 0;
    var bestDist = Infinity;
    for (var i = 0; i < cells.length; i++) {
      offsets[i] = cells[i].getBoundingClientRect().left - anchor;
      if (Math.abs(offsets[i]) < bestDist) { bestDist = Math.abs(offsets[i]); best = i; }
    }

    /* 甩一把就往前多送一格：手停在两张之间时，人的意思是「翻过去」，
       不是「退回最近那张」 */
    if (Math.abs(v) > FLICK) best += (v < 0 ? 1 : -1);
    best = Math.max(0, Math.min(cells.length - 1, best));

    var max = track.scrollWidth - track.clientWidth;
    track.scrollTo({
      left: Math.max(0, Math.min(max, track.scrollLeft + offsets[best])),
      /* 带子上的 `scroll-behavior` 这会儿被 `.is-loose` 关着，
         落位这一下用参数单独要回来 —— 参数盖得过 CSS */
      behavior: calm() ? 'auto' : 'smooth'
    });
  }

  function unsnap(track) {
    clearTimeout(track.__railSettle);
    track.classList.add('is-loose');
  }

  function resnap(track) {
    clearTimeout(track.__railSettle);
    track.__railSettle = setTimeout(function () {
      track.classList.remove('is-loose');
    }, calm() ? 0 : SETTLE);
  }

  document.addEventListener('pointerdown', function (e) {
    if (e.pointerType !== 'mouse' || e.button !== 0) return;
    if (!e.target.closest) return;

    /* `.is-draggable` 是 sync() 量出来的：放得下的带子不给抓手也不给拖 */
    var track = e.target.closest('[data-track].is-draggable');
    if (!track || e.target.closest(NO_DRAG)) return;

    var scope = track.closest('[data-rail-scope]');
    drag = {
      track: track,
      rail: scope ? scope.querySelector('[data-rail]') : null,
      id: e.pointerId,
      x0: e.clientX,
      from: track.scrollLeft,
      hist: [{ x: e.clientX, t: e.timeStamp }],
      live: false
    };
  });

  document.addEventListener('pointermove', function (e) {
    if (!drag || e.pointerId !== drag.id) return;
    var dx = e.clientX - drag.x0;

    if (!drag.live) {
      if (Math.abs(dx) < DRAG_MIN) return;
      drag.live = true;
      /* 抓住指针：手滑出带子、滑出窗口，带子照样跟手。
         指针要是已经不在了（切窗口、被系统收走），这里会抛 —— 抓不住就
         不抓，拖拽本身不该因此中断 */
      try { drag.track.setPointerCapture(e.pointerId); } catch (err) {}
      drag.track.classList.add('is-dragging');
      unsnap(drag.track);
      if (drag.rail) drag.rail.classList.add('is-live');
    }

    /* 只记账，速度等松手那下再算（见 flickSpeed）。留十个够覆盖一个窗口了 */
    drag.hist.push({ x: e.clientX, t: e.timeStamp });
    if (drag.hist.length > 10) drag.hist.shift();

    e.preventDefault();
    drag.track.scrollLeft = drag.from - dx;
  }, { passive: false });

  function endDrag(e) {
    if (!drag || (e && e.pointerId !== drag.id)) return;
    var d = drag;
    drag = null;

    d.track.classList.remove('is-dragging');
    if (d.rail) d.rail.classList.remove('is-live');
    if (!d.live) return;

    settle(d.track, flickSpeed(d.hist, e ? e.timeStamp : Infinity));
    resnap(d.track);

    /* 松手那下的 click 要吃掉 —— 卡片整张是链接，不然推完就跳进商品页了。
       捕获阶段吃才轮不到卡片自己。松在空处不会产生 click，所以还要有个
       撤销，不能让这个拦截一直挂着把下一次真点击也吃了。 */
    var eat = function (evt) { evt.stopPropagation(); evt.preventDefault(); };
    d.track.addEventListener('click', eat, true);
    setTimeout(function () { d.track.removeEventListener('click', eat, true); }, 50);
  }

  document.addEventListener('pointerup', endDrag);
  document.addEventListener('pointercancel', endDrag);

  /* 图片和链接的原生拖拽会拽出一张半透明幽灵图糊在带子上 */
  document.addEventListener('dragstart', function (e) {
    if (e.target.closest && e.target.closest('[data-track]')) e.preventDefault();
  });

  window.EB = window.EB || {};
  /* tab 切换之后带宽变了，尺要重新量 —— featured 切页后调这个 */
  window.EB.rail = { refresh: sync, refreshAll: syncAll };
})();
